import { render, staticRenderFns } from "./PlaceSocialNetworks.vue?vue&type=template&id=4072432b&scoped=true&"
import script from "./PlaceSocialNetworks.vue?vue&type=script&lang=ts&"
export * from "./PlaceSocialNetworks.vue?vue&type=script&lang=ts&"
import style0 from "./PlaceSocialNetworks.vue?vue&type=style&index=0&id=4072432b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072432b",
  null
  
)

export default component.exports